import { useReducer } from "react";

const fieldReducer = (state, action) => {
  switch (action.type) {
    case "updateValue":
      return { value: action.data, isValid: true, errorMessage: "" };
    case "setError": {
      return { value: state.value, isValid: false, errorMessage: action.error };
    }
    default:
      return state;
  }
};

const useFieldReducer = (initialValue) => {
  const defaultInitialData = {
    value: initialValue,
    isValid: true,
    errorMessage: "",
  };
  return useReducer(fieldReducer, defaultInitialData);
};

export default useFieldReducer;
